export default (props) => (
  /**
   * Ícone meramente informativo sobre o tipo 
   * de camada listada no menu de camadas.
   * Responsavel por fazer a importação 
   * de arquivos .gba
   */  
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.34356 9.36054C6.12631 9.57779 5.69665 9.50036 5.38389 9.18761C5.07114 8.87485 4.99371 8.44519 5.21096 8.22794L10.2177 3.22122C10.4349 3.00397 10.8646 3.0814 11.1773 3.39416C11.4901 3.70692 11.5675 4.13658 11.3503 4.35382L6.34356 9.36054Z"
      fill="#C3C3C3"
    />
    <path
      d="M6.02495 8.5467L9.22843 8.5467C9.67074 8.5467 10.0293 8.90526 10.0293 9.34757C10.0293 9.78988 9.67074 10.1484 9.22843 10.1484L5.22408 10.1484C4.78177 10.1484 4.42321 9.78988 4.42321 9.34757L4.42321 5.34322C4.42321 4.90091 4.78177 4.54235 5.22408 4.54235C5.66639 4.54235 6.02495 4.90091 6.02495 5.34322L6.02495 8.5467Z"
      fill="#C3C3C3"
    />
    <path
      d="M7.59388 2.1688C7.98048 2.1688 8.29388 1.8554 8.29388 1.4688C8.29388 1.0822 7.98049 0.768799 7.59389 0.768797L7.59388 2.1688ZM13.6997 7.23113C13.6997 6.84453 13.3863 6.53113 12.9997 6.53113C12.6131 6.53113 12.2997 6.84453 12.2997 7.23113H13.6997ZM7.59389 0.768797L2.99956 0.768764L2.99955 2.16876L7.59388 2.1688L7.59389 0.768797ZM0.299542 3.46881L0.299665 11.4688L1.69966 11.4688L1.69954 3.46878L0.299542 3.46881ZM2.99966 14.1687H10.9997V12.7687H2.99966V14.1687ZM13.6997 11.4688V7.23113H12.2997V11.4688H13.6997ZM10.9997 14.1687C12.4909 14.1687 13.6997 12.9599 13.6997 11.4688H12.2997C12.2997 12.1867 11.7177 12.7687 10.9997 12.7687V14.1687ZM0.299665 11.4688C0.299688 12.9599 1.50851 14.1687 2.99966 14.1687V12.7687C2.2817 12.7687 1.69968 12.1867 1.69966 11.4688L0.299665 11.4688ZM2.99956 0.768764C1.50837 0.768754 0.29952 1.97761 0.299542 3.46881L1.69954 3.46878C1.69953 2.7508 2.28157 2.16876 2.99955 2.16876L2.99956 0.768764Z"
      fill="#C3C3C3"/>
  </svg>
);
